module.exports = __webpack_public_path__ + "img/yangmyung-logo.ab04f07b.svg";